// Hub-tab switcher (Phase 5 Step 8 — mid-layer extraction, dependency-injected).
// Uses document directly (no ui import) and reaches all app fns via _deps (injected at boot).
// wlLiveQueue is module-private: it's write-only/vestigial (only setHubTab reset it; nothing reads it).
// setHubTab moved verbatim (8-space indent preserved; esbuild strips it on minify).
let _deps = {};
export function configure(d) { _deps = { ..._deps, ...d }; }

        let wlLiveQueue = [];   // moved from app.js (write-only back-compat reset; not read anywhere)

        export function setHubTab(tab) {
            // Migrated to the centralized setter (TODO-1): writes the state.activeHubTab global
            // AND emits 'hubTabChanged' so any subscriber can react. Behavior is identical
            // to the old `state.activeHubTab = tab` — this just makes the change observable.
            _deps.setActiveHubTab(tab);
            document.querySelectorAll('.hub-tab').forEach(btn => {
                const on = btn.dataset.hub === tab;
                btn.classList.toggle('bg-blue-600', on);
                btn.classList.toggle('text-white', on);
                btn.classList.toggle('text-slate-400', !on);
            });
            // Screener content = all .hub-screener blocks; the other two are single panels.
            document.querySelectorAll('.hub-screener').forEach(el => el.classList.toggle('hidden', tab !== 'screener'));
            const wl = document.getElementById('watchlistTab');
            const pf = document.getElementById('portfolioTab');
            const gr = document.getElementById('groupRankTab');
            const al = document.getElementById('alertsTab');
            if (wl) wl.classList.toggle('hidden', tab !== 'watchlist');
            if (pf) pf.classList.toggle('hidden', tab !== 'portfolio');
            if (gr) gr.classList.toggle('hidden', tab !== 'groups');
            if (al) al.classList.toggle('hidden', tab !== 'alerts');
            if (tab === 'groups') { if (typeof _deps.updateGroupRsRegimeBadge === 'function') _deps.updateGroupRsRegimeBadge(); _deps.renderGroupRankings(); }
            if (tab === 'watchlist' && typeof _deps.renderWatchlist === 'function') {
                _deps.renderWatchlist();
                // Kick the live price feed immediately so prices populate without waiting
                // for the rolling cycle; reset the queue to start a fresh full pass now.
                if (typeof wlLiveQueue !== 'undefined') wlLiveQueue = [];
                if (typeof _deps.wlLiveTickOnce === 'function') { _deps.wlLiveTickOnce(); }
            }
            if (tab === 'portfolio' && typeof _deps.renderPortfolio === 'function') _deps.renderPortfolio();
            if (tab === 'alerts' && typeof _deps.renderAlertsFeed === 'function') {
                _deps.renderAlertsFeed();
                // Opening the feed marks everything read; badge clears.
                if (typeof _deps.markAllRead === 'function') _deps.markAllRead();
                if (typeof _deps.updateAlertsTabBadge === 'function') _deps.updateAlertsTabBadge();
            }
        }

if (typeof window !== 'undefined') {
    window.setHubTab = setHubTab;                    // REQUIRED: app.js-built onclick="setHubTab(...)" resolves off window
    window.hub = { configure, deps: () => _deps };   // module DI/verification surface
}
